import { UserInviteForm } from '../components/UsersGrid.tsx';

/** 사용자 초대 (tenant_admin) */
export function UserInvitePage() { return <UserInviteForm base="/users" backTo="/users" description="이메일로 초대 링크를 보냅니다. 초대받은 사용자가 비밀번호·MFA 를 설정하면 활성화됩니다." rolesPath="/roles" deptsPath="/org/departments" />; }
